export default (state = false, action) => {
  switch (action.type) {
    case 'ONLY_CASH_SUCCESS':
    case 'PARTICIPANT_VISUALIZATION_CONTEXT_SUCCESS':
      return action.payload.data
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/App/MainMenu/OnlyCash/reducer.js